export const IMG_52B = [
    '/images/private/52b/52b_1.jpg',
    '/images/private/52b/52b_2.jpg',
    '/images/private/52b/52b_3.jpg',
    '/images/private/52b/52b_4.jpg',
    '/images/private/52b/52b_5.jpg',
    '/images/private/52b/52b_6.jpg',
    '/images/private/52b/52b_7.jpg',
    '/images/private/52b/52b_8.jpg',
    '/images/private/52b/52b_9.jpg',
    '/images/private/52b/52b_10.jpg',
    '/images/private/52b/52b_11.jpg',
    '/images/private/52b/52b_12.jpg',
    '/images/private/52b/52b_13.jpg',
];

export const IMG_52A = [
    '/images/private/52a/52a_1.jpg',
    '/images/private/52a/52a_2.jpg',
    '/images/private/52a/52a_4.jpg',
    '/images/private/52a/52a_6.jpg',
    '/images/private/52a/52a_7.jpg',
    '/images/private/52a/52a_8.jpg',
];
export const DARZA = [
    '/images/private/darzu/darzu_18_1.jpg',
    '/images/private/darzu/darzu_18_2.jpg',
    '/images/private/darzu/darzu_18_3.jpg',
    '/images/private/darzu/darzu_18_4.jpg',
    '/images/private/darzu/darzu_18_5.jpg',
    '/images/private/darzu/darzu_18_6.jpg',
];

export const BULDURU = [
    '/images/private/bulduru-1.jpg',
    '/images/private/bulduru-2.jpg',
];

export const SAMARA = [
    '/images/private/samara/samara-1.jpg',
    '/images/private/samara/samara-2.jpg',
];

export const GERTRUDES = [
    '/images/private/gertrudes1/gertrudes1_1.jpg',
    '/images/private/gertrudes1/gertrudes1_2.jpg',
    '/images/private/gertrudes1/gertrudes1_3.jpg',
    '/images/private/gertrudes1/gertrudes1_4.jpg',
    '/images/private/gertrudes1/gertrudes1_5.jpg',
];

export const MILDAS_15 = [
    '/images/private/mildas15/mildas15-1.jpg',
    '/images/private/mildas15/mildas15-2.jpg',
    '/images/private/mildas15/mildas15-3.jpg',
    '/images/private/mildas15/mildas15-4.jpg',
    '/images/private/mildas15/mildas15-5.jpg',
    '/images/private/mildas15/mildas15-6.jpg',
    '/images/private/mildas15/mildas15-7.jpg',
];

export const MILDAS_3 = [
    '/images/private/mildas3/mildas3-1.jpg',
    '/images/private/mildas3/mildas3-2.jpg',
    '/images/private/mildas3/mildas3-3.jpg',
    '/images/private/mildas3/mildas3-4.jpg',
    '/images/private/mildas3/mildas3-5.jpg',
    '/images/private/mildas3/mildas3-6.jpg',
    '/images/private/mildas3/mildas3-7.jpg',
    '/images/private/mildas3/mildas3-8.jpg',
    '/images/private/mildas3/mildas3-9.jpg',
];

export const DIKLU = [
    '/images/private/diklu/diklu-1.jpg',
    '/images/private/diklu/diklu-2.jpg',
    '/images/private/diklu/diklu-3.jpg',
    '/images/private/diklu/diklu-4.jpg',
    '/images/private/diklu/diklu-5.jpg',
];

export const LATTELECOM = [
    '/images/private/lattelecom/lattelecom-1.jpg',
    '/images/private/lattelecom/lattelecom-2.jpg',
    '/images/private/lattelecom/lattelecom-3.jpg',
    '/images/private/lattelecom/lattelecom-4.jpg',
    '/images/private/lattelecom/lattelecom-5.jpg',
    '/images/private/lattelecom/lattelecom-6.jpg',
    '/images/private/lattelecom/lattelecom-7.jpg',
    '/images/private/lattelecom/lattelecom-8.jpg',
    '/images/private/lattelecom/lattelecom-9.jpg',
    '/images/private/lattelecom/lattelecom-10.jpg',
];

export const ANGEL = [
    '/images/private/angel/angel-1.jpg',
    '/images/private/angel/angel-2.jpg',
    '/images/private/angel/angel-3.jpg',
    '/images/private/angel/angel-4.jpg',
    '/images/private/angel/angel-5.jpg',
    '/images/private/angel/angel-6.jpg',
    '/images/private/angel/angel-7.jpg',
    '/images/private/angel/angel-8.jpg',
    '/images/private/angel/angel-9.jpg',
    '/images/private/angel/angel-10.jpg',
    '/images/private/angel/angel-11.jpg',
];

export const KONKORDIJA = [
    '/images/private/konkordijas/konkordijas-1.jpg',
    '/images/private/konkordijas/konkordijas-2.jpg',
    '/images/private/konkordijas/konkordijas-3.jpg',
    '/images/private/konkordijas/konkordijas-4.jpg',
    '/images/private/konkordijas/konkordijas-5.jpg',
    '/images/private/konkordijas/konkordijas-6.jpg',
    '/images/private/konkordijas/konkordijas-7.jpg',
    '/images/private/konkordijas/konkordijas-8.jpg',
];

export const SAULES = [
    '/images/2022/1_Saules/1.webp',
    '/images/2022/1_Saules/2.webp',
    '/images/2022/1_Saules/3.webp',
    '/images/2022/1_Saules/4.webp',
    '/images/2022/1_Saules/5.webp',
    '/images/2022/1_Saules/6.webp',
    '/images/2022/1_Saules/7.webp',
    '/images/2022/1_Saules/8.webp',
    '/images/2022/1_Saules/9.webp',
];

export const MENCU = [
    '/images/2022/2_Mencu/1.webp',
    '/images/2022/2_Mencu/2.webp',
    '/images/2022/2_Mencu/3.webp',
    '/images/2022/2_Mencu/4.webp',
]

export const LIBIESU = [
    '/images/2022/3_Libiesi/1.webp',
    '/images/2022/3_Libiesi/2.webp',
    '/images/2022/3_Libiesi/3.webp',
    '/images/2022/3_Libiesi/4.webp',
];